import {
    Directive, ElementRef, TemplateRef, Input, HostListener, ViewChildren, AfterViewInit
    , AfterContentInit
} from '@angular/core';
import * as jsPDF from 'jspdf';
declare var jquery: any;
declare var $: any;

@Directive({
    selector: '[appPdfConvertor]'
})
export class PdfConvertorDirective implements AfterViewInit {
    @ViewChildren("#test1")
    public test;
    @Input() elementId: string;
    public htmlString;


    constructor(el: ElementRef) { }

    ngAfterViewInit() {

    }
    @HostListener('click', ['$event']) onClick($event) {
        this.convertPdf('Output', true);
    }

    convertPdf(outputFile, selectable) {
        this.htmlString = $(`#${this.elementId}`).html();
        var doc = new jsPDF("p", "pt", "letter");

        if (selectable) {
            var specialElementHandlers = {
                /* '#editor': function (element, renderer) {
              return true;
          }*/
            };
            // this produces pdf with selectable text no css
            doc.fromHTML(this.htmlString, 15, 15, {
                'width': 170, 'elementHandlers': specialElementHandlers
            },
                function () {
                    doc.save('sample.pdf');
                }
            );
        }
        else {
            // this produces pdf with css but no selectable text
            doc.addHTML(this.htmlString, function () {
                doc.save(`${outputFile}.pdf`);
            });
        }


    };
}
